import script from "./PoliticaView.vue?vue&type=script&setup=true&lang=js"
export * from "./PoliticaView.vue?vue&type=script&setup=true&lang=js"

import "./PoliticaView.vue?vue&type=style&index=0&id=96a281fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96a281fc"]])

export default __exports__